module.exports = __webpack_public_path__ + "img/dingdan.27b7341a.png";